import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer">
      {/* Main Footer */}
      <div className="bg-[#1a1a1a] text-white">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Logo */}
            <div>
              <h3 className="font-bold text-lg tracking-wide mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                614 SHOP LOCAL
              </h3>
              <p className="text-gray-400 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Connecting small businesses, shoppers, and markets together.
              </p>
              <p className="text-gray-500 text-xs mt-3 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Part of{" "}
                <a href="https://theshoplocalcollective.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#42D78A] transition-colors">
                  The Shop Local Collective
                </a>
                .
              </p>
            </div>

            {/* Address */}
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-[#42D78A] flex-shrink-0 mt-0.5" />
              <div className="text-sm text-gray-300" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                <p>Columbus, Ohio</p>
                <p>United States</p>
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-4">
              <a href="https://instagram.com/614shoplocal" target="_blank" rel="noopener noreferrer" aria-label="614 Shop Local on Instagram" className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-[#42D78A] hover:text-[#42D78A] transition-colors" data-testid="footer-instagram">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
              <a href="https://facebook.com/614shoplocal" target="_blank" rel="noopener noreferrer" aria-label="614 Shop Local on Facebook" className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-[#42D78A] hover:text-[#42D78A] transition-colors" data-testid="footer-facebook">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a href="https://discord.gg/r8ASqAZ7N8" target="_blank" rel="noopener noreferrer" aria-label="The Shop Local Collective Discord" className="w-10 h-10 rounded-full border border-gray-600 flex items-center justify-center hover:border-[#42D78A] hover:text-[#42D78A] transition-colors" data-testid="footer-discord">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                  <path d="M20.317 4.369A19.791 19.791 0 0016.558 3c-.163.29-.35.682-.48.992a18.27 18.27 0 00-4.156 0A10.47 10.47 0 0011.442 3a19.736 19.736 0 00-3.762 1.37C5.299 7.918 4.652 11.38 4.975 14.79A19.9 19.9 0 009.58 17.12c.371-.506.701-1.043.984-1.608a12.79 12.79 0 01-1.55-.743c.13-.095.257-.194.379-.295 2.986 1.378 6.223 1.378 9.173 0 .124.101.251.2.38.295-.493.29-1.012.54-1.553.744.283.564.613 1.1.984 1.606a19.86 19.86 0 004.607-2.328c.379-3.954-.647-7.385-2.667-10.422zM9.98 12.692c-.897 0-1.63-.826-1.63-1.84s.717-1.84 1.63-1.84c.913 0 1.646.834 1.63 1.84 0 1.014-.717 1.84-1.63 1.84zm4.04 0c-.897 0-1.63-.826-1.63-1.84s.717-1.84 1.63-1.84c.913 0 1.646.834 1.63 1.84 0 1.014-.717 1.84-1.63 1.84z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              &copy; {new Date().getFullYear()} 614 Shop Local. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-500" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              <Link to="/directory" className="hover:text-[#42D78A] transition-colors">Directory</Link>
              <Link to="/privacy-policy" className="hover:text-[#42D78A] transition-colors">Privacy</Link>
              <Link to="/terms-and-conditions" className="hover:text-[#42D78A] transition-colors">Terms</Link>
              <Link to="/accessibility" className="hover:text-[#42D78A] transition-colors">Accessibility</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
